import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { AppDialog, AppDialogBody, AppDialogHeader } from "@components/@base"
import { dsColorNew } from "@palette"


// The "Show all" list of a table cell: header with the count, a row of filters and the items in columns
export default function AppListDialog({ open, onClose, icon, title, noun, total, shown, filters, children, containerProps = {} }) {
	const subtitle = shown === total ? `${total} ${noun}` : `Showing ${shown} of ${total} ${noun}`

	return <AppDialog open={open} onClose={onClose} maxWidth="md">
		<AppDialogHeader icon={icon} title={title} subtitle={subtitle} onClose={onClose}/>
		<AppDialogBody sx={{ pt: 0.5 }}>
			<Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 2, mb: 2, pt: 1 }}>
				{filters}
			</Box>
			{shown > 0 && <Box sx={{
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
				columnGap: 1.5,
				maxHeight: '50vh',
				overflowY: 'auto',
				p: 1,
				border: `1px solid ${dsColorNew.grayBorder}`,
				borderRadius: '12px',
				backgroundColor: dsColorNew.tableRowAlt,
				...containerProps,
			}}>
				{children}
			</Box>}
			{!shown && <Box sx={{
				display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1,
				py: 6, border: `1px dashed ${dsColorNew.grayBorder}`, borderRadius: '12px', color: dsColorNew.textSubtle,
			}}>
				<IconSeeker icon="magnifying-glass" sx={{ fontSize: 18 }}/>
				<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted }}>No results for the given filters</Typography>
			</Box>}
		</AppDialogBody>
	</AppDialog>
}

// One entry of the list: a quiet row that lights up under the pointer
export const listItemSx = {
	px: 1.25,
	py: 0.75,
	m: 0,
	minWidth: 0,
	borderRadius: '8px',
	'&:hover': { backgroundColor: dsColorNew.white, boxShadow: `inset 0 0 0 1px ${dsColorNew.grayBorder}` },
}
